import React, { useContext, useEffect, useRef } from "react";
import styles from "./DesignerHeader.module.css";
import UndoRedo from "../UndoRedo/UndoRedo";
import DeviceTypeSelector from "../DeviceTypeSelector/DeviceTypeSelector";
import FormOptions from "../FormOptions/FormOptions";
import { Row, Col, Container, Nav, Navbar, ButtonToolbar, ButtonGroup } from "react-bootstrap";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AppsIcon from "@material-ui/icons/Apps";
import Divider from "@material-ui/core/Divider";
import SaveOption from "../FormOptions/SaveOption";
import ThemeSelector from "../Theme/ThemeSelector";
import ThemesLayout from "../Theme/ThemesLayout";
import { useState } from "react";
// import {AppContext} from '../../../../Resources/CanvasContextFile'
import DownArrow from "../../../../Icons/DownArrow";
import { useTranslation } from "react-i18next";
// import Stack from "@Mui/material/Stack";
import { useDispatch, addContexts, useSelector } from "../../../../Redux";
import { ReactComponent as Layer } from "../../../../Icons/theme-icon.svg";
import { ReactComponent as Gear } from "../../../../Icons/Gear.svg";
import { ReactComponent as Deployed } from "../../../../Icons/Deployed.svg";
import { ReactComponent as SaveIcon } from "../../../../Icons/Save-Stroke.svg";
import { ReactComponent as DataModel } from "../../../../Icons/DataModel.svg";
import { ReactComponent as DownloadIcon } from "../../../../Icons/DownloadIcon.svg";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import TooltipMui from "@material-ui/core/Tooltip";
import { userDefinedThemes, saveTheme } from "../../../../components/IFormDesignerLayout/RequestLogic";
import { useMediaQuery } from "@material-ui/core";
import { cloneDeep } from "lodash-es";
import formatDistanceToNow from "date-fns/esm/formatDistanceToNow/index.js";
import axios from "../../../../axios";
import CustomizedAlert from "../../../../ReusableComponents/Alert/CustomizedAlert";
import { GetStateFromData } from "../../../CustomHooks/CustomHooks";
import { BlueButton, DullButton } from "../../../../ReusableComponents/GetButtons/GetButtons";
import { focusElement } from "../../../../Resources/globalFunctions";
import { modify, modify_form, publish } from "../../../constant";
import MoreSaveOptions from "../MoreSaveOptions";
import CircularProgress from "@material-ui/core/CircularProgress";
import { GetState } from "../../../CustomHooks/CustomHooks.js";
import { updateStateInRedux } from "../../../../Redux/Actions/FormStateActions.js";
import "../../../../ReusableComponents/GetButtons/getButton.css"
import MarvinContainer from "../Marvin/MarvinContainer";
import { getDevice, getSelectedControlType, handleMarvinFormOpen } from "../../IFormDesignerLogic";
import { validControlsMarvinArray } from "../Marvin/MarvinInputForm/validControlsMarvin";
import DownArrow1 from "../../../../Icons/downArrow.svg";

const useStyles = makeStyles(() => ({
  Iconbutton: {
    width: "28px !important",
    height: "28px !important",
  
    "& span": {
      width: "28px !important",
      paddingRight: "0px !important"
    },

    "& .MuiIconButton-label": {
      paddingRight: "0px !important"
    }
  },
  IconbuttonTheme: {
    width: "28px",
    height: "28px !important",
    marginTop: "3px !important",
    marginRight: "0px !important",

    "& span": {
      width: "28px"
    }
  },
  iconButtonroot: {
    "&:hover": {
      backgroundColor: "rgba(0, 114, 198, 0.04)"
    },
    "&:focus": {
      backgroundColor: "rgba(0, 114, 198, 0.04)"
    }
  },
  Settingbutton: {
    width: "30px",
    marginLeft: "-1px !important",
    marginRight: "0px !important",
    marginTop: "3px !important",
    cursor: "default !important"
  },
  tooltip: {
    maxWidth: "260px",
    // maxHeight: "96px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12
    // marginTop: "0px",
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075"
    },
    color: "white",
    fontSize: 15
  },
  ellipsis: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  },
  leftActions: {
    display: "flex",
    alignItems: "center",
    maxWidth: "350px",
  },
  rightActions: {
    display: "flex",
    zIndex: (style) => style.matches ? "unset" : 1,
    // marginLeft: (style) => style.matches ? "unset" : "16px",
    height: "100%"
    // width: "350px"
  },
  applicationDetails: {
    display: "flex",
    gap: "16px",
    height: "100%",
    alignItems: "center",
    marginLeft: "16px"
  },
  applicationName: {
    maxWidth: "100px",
    textOverflow: "ellipsis",
    textWrap: "nowrap",
    overflow: "hidden"
  },
  status: {
    fontSize: "12px",
    display: "flex",
    alignItems: "center"
  },
  StatusDot: {
    height: "7px",
    width: "7px",
    borderRadius: "50%",
    marginRight: "5px",
    // background: (style) =>
    //   style?.applicationStatus === "draft" || style?.applicationStatus?.toLowerCase() === "l"
    //     ? "#147AFC"
    //     : style?.applicationStatus === "published" || style?.applicationStatus?.toLowerCase() === "r"
    //     ? "#29AC47"
    //     : style?.applicationStatus === "deployed" || style?.applicationStatus?.toLowerCase() === "r"
    //     ? "#29AC47"
    //     : style?.applicationStatus === "local"
    //     ? "#20BBC1"
    //     : style?.applicationStatus === "registered"
    //     ? "008E58"
    //     : "#FECC2F"
  },
  formList: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "28px",
    padding: "0 10px",
    background: "#f8f8f8",
    borderRadius: "2px",
    backgroundColor: "#fff",
    border: "1px solid #c4c4c4",
    gap: "10px"
  },
  themeIcon: {
    "& path": {
      fill: "#606060"
    }
  },
  themeSelected: {
    "& path": {
      stroke: "#0072c6"
    }
  },
  actionButtonGroup: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    marginRight: "2px"
  },
  actionButton: {
    margin: "0 !important",
    height: "28px !important"
  },
  saveButton: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    margin: "0 !important",
    height: "26px !important",
    borderColor: "#0072c6 !important",
    color: "#0072c6 !important",
    borderRadius: "2px !important",
    marginRight: (style) => style.isProcessForm && !style.isMarvinEnabled ? "16px !important" : "0"
  },
  deviceBreakpoint: {
    display: "flex",
    alignItems: "center",
    height: "40px",
  },
  deployButton: {
    height: "26px !important",
    margin: "0 !important",
    padding: "0 5px !important",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    borderRadius: "2px !important",
    marginRight: style => style.isMarvinEnabled ? "0" : "16px !important"
  },
  downArrow: {
    width: "10px",
    height: "10px",
    userSelect: "none",
    verticalAlign: "middle"
  }
}));

const DesignerHeader = (props) => {
  
  const translationStyles1 =
  window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const css = { border: "1px solid rgba(0, 0, 0, .125)" };
  
  const contexts = GetStateFromData(props.containerId);
  const marvinContexts = GetStateFromData(props?.containerId, "marvinData");
  const { marvinButtonSelected, isMarvinEnabled } = marvinContexts.marvinStates;
  const { controlSelected, routeCriteriaApplied, loginPortal } = GetState("controlSelected", "routeCriteriaApplied", "loginPortal", "renderDesignerHeader");

  const matches = useMediaQuery("(min-width: 1181px)");
  const tabMedia = useMediaQuery("(max-width: 768px)");
  const isProcessForm = props.applicationData?.formPageType === "Processes";
  const getCurrentDevice = getDevice()

  const classes = useStyles({
    isMarvinEnabled,
    isProcessForm,
    matches,
    applicationStatus: props.applicationData?.status?.toLowerCase()
  });

  const dispatch = useDispatch();

  const {
    updateJson,
    toggleProperty,
    setToggleProperty,
    openProperties,
    setOpenProperties,
    activePage,
    activeSubForm,
    propertyPinned,
    activeApplication,
    device,
    setShowPagesSubForms,
    showAlertConfirmNotifications,
    formState2,
    setSelectedControl,
    isButtonSubformOpen,
    // setDoclistRerenderCount,
    setThemeOpen,
    themeOpen,
    setThemeResetDone,
    setThemeResetValDone,
    openCanvasForSubform
  } = contexts.contexts;

  const { updatedComponentInFormState } = updateJson;

  const [showTheme, setShowTheme] = useState(false);
  const [disablePropertyBtn, setDisablePropertyBtn] = useState(false);
  const [openPopupSave, setOpenPopupSave] = useState(false);
  const [saveAppTemplate_popup, setSaveAppTemplate_popup] = useState("closed");
  const [formCorrupt, setFormCorrupt] = useState(false);
  const [formLoad, setFormLoad] = useState(true);

  const isTabMediaMatches = useMediaQuery("(min-width: 834px)");
  const deviceContext = device?.toLowerCase();
  const deviceMode = document.querySelector("#canvasId")?.getAttribute("deviceMode")?.toLowerCase();
  // const [updateTheme, setUpdateTheme] = useState({})

  const distanceFromTop = useRef(false);
  const { selectedControl } = props;
  const [formStateTheme, setFormStateTheme] = useState({});
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
  });
  const controlType = getSelectedControlType(false, controlSelected, activePage, activeSubForm);
  const isMarvinDisabled = controlType === "Control" && !validControlsMarvinArray?.includes(controlSelected?.elem_type);

  function isObject(obj) {
    return obj !== undefined && obj !== null && obj.constructor == Object;
  }

  window.mf_iforms_corrupt = (val) => {
    setFormCorrupt(val);
  };

  window.formBuilderCheck = () => {
    if (window.formBuffer) {
      if (isObject(window?.formBuffer)) {
        if (
          Object.keys(window?.formBuffer).length === 0 ||
          !Object.keys(window?.formBuffer).includes("children")
        ) {
          setFormLoad(true);
        } else setFormLoad(false);
      } else setFormLoad(true);
    } else setFormLoad(true);
  };

  //  const [formPageStyle,setformPageStyle]=useState({});

  useEffect(() => {
    if (typeof formStateTheme === "object" && formStateTheme !== null) {
      if (Object.keys(formStateTheme).length === 0) {
        setFormStateTheme(cloneDeep(formState2?.theme || {}));
      }
    }
  }, [formState2?.theme]);

  // useEffect(()=>{
  //   if(typeof formPageStyle==='object' && formPageStyle !==null){
  //     if(Object.keys(formPageStyle).length===0){
  //       setformPageStyle(cloneDeep(formState2?.pageStyle || {}));
  //     }
  //   }
  // },[formState2?.pageStyle])

  const [themeDetailsReset, setThemeDetailsReset] = useState({
    systemDefinedThemes: [],
    userDefinedThemes: [],
    appliedTheme: {}
  });

    // Reset stale theme state when switching between pages/subforms
  // so that toggleDrawer (grey cross) doesn't restore old subform theme
  useEffect(() => {
    setFormStateTheme(cloneDeep(formState2?.theme || {}));
    setThemeDetailsReset({
      systemDefinedThemes: [],
      userDefinedThemes: [],
      appliedTheme: {}
    });
  }, [activePage, activeSubForm]);
  
  const {saveload} = GetState(
    "saveload",
  );
  // function handleToggle()
  // {
  //   setToggleProperty(false)

  //   console.log("toggle property in handletoggle", toggleProperty)
  // }

  useEffect(() => {
    const element = document.getElementById("designerHeader");

    //    document.querySelector('#root').addEventListener('click',handleToggle)

    if (element !== undefined) {
      const rect = element.getBoundingClientRect();
      var height = rect.height;
      var top = rect.top;
      var totalDistance = height + top;
      distanceFromTop.current = totalDistance;
    }
  }, []);
  console.log("counter", "checking designerHeaderrender");
  const handleDownloadClick = (data) => {
    try {
      // Assuming the API response is a JSON object, convert it to a string
      const jsonData = JSON.stringify(data);

      // Create a Blob from the JSON data
      const blob = new Blob([jsonData], { type: "application/json" });

      // Create a URL for the Blob data
      const url = URL.createObjectURL(blob);

      // Create a temporary anchor tag to trigger the download
      const tempAnchor = document.createElement("a");
      tempAnchor.href = url;
      tempAnchor.download = "data.json"; // Specify the desired filename

      // Trigger a click on the anchor tag to initiate the download
      tempAnchor.click();
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "success",
        alertContentMsg: "The picklist has been exported successfully."
        // autoHideDuration: 6000,
      });
      // Clean up by revoking the URL object
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error fetching API or creating the file:", error);
    }
  };

  const handleExportPicklist = () => {
    const picklistIds = [];
    if (formState2?.picklistInstanceArray?.length > 0) {
      formState2?.picklistInstanceArray?.forEach((pick) => {
        picklistIds.push(pick?.picklist_instance_id);
      });
      const exportPicklistPayload = {
        picklistInstanceIds: picklistIds
      };
      axios
        .post("/idesign/exportpicklistinstance", exportPicklistPayload, { withCredentials: true })
        .then((res) => {
          console.log("res", res, res?.data);
          if (res) {
            handleDownloadClick(res);
          }
        })
        .catch((err) => {
          //   alert("unable to logout: Logout API failed");
          console.log("No response");
        });
    }
  };

  const isSystemDefinedCustomControl = (name) => {
    switch (name) {
      case "slider":
        return true;
      case "captcha":
        return true;
      case "doclist":
        return true;
      case "toggle":
        return true;
      default:
        return false;
    }
  };

  function togglePropertyPanel() {
    // console.log(
    //   "toggleProperty :: ",
    //   toggleProperty,
    //   "| selectedControl :: ",
    //   selectedControl,
    //   "| propertyPinned", propertyPinned
    // );
    setThemeOpen(false);
    setShowTheme("");

    if (
      selectedControl?.current === null ||
      selectedControl?.current === undefined ||
      selectedControl?.current === "" ||
      selectedControl?.current.elem_type === null ||
      selectedControl?.current.elem_type === undefined ||
      selectedControl?.current.elem_type === ""
    ) {
      setSelectedControl(formState2);
    }
    if (
      selectedControl?.current !== null &&
      selectedControl?.current !== undefined &&
      selectedControl?.current !== "" &&
      selectedControl?.current.elem_type !== null &&
      selectedControl?.current.elem_type !== undefined &&
      selectedControl?.current.elem_type !== "" &&
      (selectedControl?.current.elem_type !== "CustomControl" ||
        (selectedControl?.current.elem_type === "CustomControl" &&
          isSystemDefinedCustomControl(selectedControl?.current.controlName)))
    ) {
      // console.log("selectedControl?.current :: ", selectedControl?.current);
      if (disablePropertyBtn) {
        setDisablePropertyBtn(false);
      }
      //here
      setToggleProperty(true);
      setOpenProperties(true);
      // setSelectedControl(controlSelected);
      console.log("toggle property in togglepropertypanel", toggleProperty);
    } else if (
      selectedControl?.current.elem_type === "CustomControl" &&
      !isSystemDefinedCustomControl(selectedControl?.current.controlName)
    ) {
      setDisablePropertyBtn(true);
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "CustomControlNoProperty"
      });
      setToggleProperty(false);
      // alert("CustomControl has no properties window");
    } else {
      setDisablePropertyBtn(true);
      // console.log('No control selected! :: ');
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "SelectControlForProperty"
      });
      // alert("Select any control to show the property!");
    }
  }

  function handleThemeList(action, newTheme) {
    try {
      if (action === "add") {
        saveTheme(newTheme)
          .then((response) => {
            if (response && response.status === 200) {
              props.handleThemeSelector("Apply", newTheme, "upload");

              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "success",
                vertical: "bottom",
                horizontal: "left",
                alertContentKey: "THEME_SAVED_SUCCESSFULLY"
              });
            }
          })
          .catch(function (error) {});

        props.setThemeList({
          ...props.themeList,
          userDefinedThemes: [...props.themeList["userDefinedThemes"], newTheme]
        });
      } else if (action === "delete") {
      } else if (action === "download") {
      }
    } catch (e) {}
  }

  // function returnResetTheme(){
  //   if(props?.themeDetailsReset?.appliedTheme && Object.keys(props?.themeDetailsReset?.appliedTheme)?.length>0){
  //     return cloneDeep(props.themeDetailsReset.appliedTheme);
  //   }
  //   else{
  //     return cloneDeep(formState2.theme);
  //   }
  // }

  function handleThemeSelector(action, newTheme, str = "") {
    if (action === "Apply") {
      setThemeOpen(false);
      props.setThemeList({ ...props.themeList, appliedTheme: newTheme });
      if (newTheme) {
        formState2.themeName = newTheme.themeName;
        if(activePage){
        formState2.pageTheme = true;        
        }
        formState2.theme = { ...newTheme };
        // if(str === "save")
        // setUpdateTheme({...newTheme})
        // formState2.theme.themeName = newTheme.themeName;
        updatedComponentInFormState();
        // props.formData.theme = newTheme;
        props.applyChanges(props.formData);
        setShowTheme(false);
        if (str === "") {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            vertical: "bottom",
            horizontal: "left",
            alertContentKey: `${newTheme?.themeName} ${t("translation:theme has been applied successfully")}`,
            autoHideDuration: 4000
          });
        }
      }
    } else if (action === "Reset") {
      setThemeResetDone(true);
      setThemeResetValDone(Date.now());
      const customStyleCopy = cloneDeep(formState2?.theme);
      const customCssKeys = [
        "CustomStyle",
        "ApplicationTheme",
        "TextBoxCustomStyle",
        "RadioCustomStyle",
        "CheckBoxCustomStyle",
        "ToggleCustomStyle",
        "ButtonCustomStyle",
        "SectionsCustomStyle",
        "LabelCustomStyle",
        "HorizontalTabs",
        "VerticalTabs",
        "HorizontalWizard",
        "VerticalWizard",
        "Tables",
        "DocList"
      ];

      // setThemeOpen(false)
      if (themeDetailsReset?.appliedTheme && Object.keys(themeDetailsReset?.appliedTheme)?.length > 0) {
        props.formData.theme = cloneDeep(themeDetailsReset?.appliedTheme);
        formState2.theme = cloneDeep(themeDetailsReset?.appliedTheme);
        Object.keys(customStyleCopy).forEach((style) => {
          customCssKeys.forEach((customcss) => {
            if (style === customcss) {
              props.formData.theme[customcss] = customStyleCopy?.[customcss];
              formState2.theme[customcss] = customStyleCopy?.[customcss];
            }
          });
        });
        dispatch(
          updateStateInRedux({
            name: "doclistRerenderCount",
            value: new Date(),
            key: props.containerId,
          })
        );
      } else {
        if (Object.keys(formStateTheme).length > 0) {
          props.formData.theme = cloneDeep(formStateTheme);
          formState2.theme = cloneDeep(formStateTheme);
          Object.keys(customStyleCopy).forEach((style) => {
            customCssKeys.forEach((customcss) => {
              if (style === customcss) {
                props.formData.theme[customcss] = customStyleCopy?.[customcss];
                formState2.theme[customcss] = customStyleCopy?.[customcss];
              }
            });
          });
          dispatch(
            updateStateInRedux({
              name: "doclistRerenderCount",
              value: new Date(),
              key: props.containerId,
            })
          );
        }
        // if(Object.keys(formPageStyle).length>0){
        // formState2.pageStyle= cloneDeep(formPageStyle);
        // }
      }
      updatedComponentInFormState();
      props.applyChanges(props.formData);
    } else if (action === "showChanges") {
      // props.setThemeList((prev)=>{return{...prev, 'appliedTheme': newTheme}})
      props.formData.theme = { ...newTheme };
      // props.applyChanges(props.formData);
      updatedComponentInFormState();
    } else if (action === "Cancel") {
      setShowTheme(false);
    }
  }

  const { t } = useTranslation(["styles", "translation"]);

  var widthValueForArabicPages = {
    // position: "absolute",
    alignItems: "center",
    right: t("rightVal"),
    left: t("leftVal")
  };

  var widthValueForArabicSavePreview = {
    // position: "absolute",
    alignItems: "center",
    right: t("leftVal"),
    left: t("rightVal")
  };

  function handleSave(e) {
    e.stopPropagation();
    window.loading(true);
    var currscreen = window.activeScreen;
    var artifactType1 = "";
    var actionName1 = "";
    var messageFormatId1 = "";
    var actionId1 = modify;
    var id1 = "";
    var name1 = "";

    if (currscreen === "applications" || currscreen === undefined ) {
      artifactType1 = "Portals";
      actionName1 = "modify";
      messageFormatId1 = "ifd_0009";
      actionId1 = modify;
      id1 = props.applicationData.applicationId;
      name1 = props.applicationData.applicationName;
    } else if (currscreen === "forms") {
      artifactType1 = "form";
      messageFormatId1 = "ifd_0023";
      actionId1 = modify_form;
      actionName1 = "update";
      id1 = props.applicationData.applicationId;
      name1 = props.applicationData.applicationName;
    }

    if (props.applicationData.applicationId) {
      const object = {
        artifactType: artifactType1,
        id: id1.toString(),
        name: name1
      };
      window.activityStream(object, actionId1, actionName1, messageFormatId1);
    }

    if(e?.target?.blur) {
      e.target.blur();
    }

    window
      .callSpecifiedFunctions()
      .then((res) => {
        window.loading(false);
      })
      .catch((err) => {
        window.loading(false);
      });
  }

  function handleDeployClick(e) {
    if (window.publishApplication) {
      window.publishApplication(props.applicationData);
      e.target.blur();
    } else {
        showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t("translation:Configure route criteria command before deploying login portal")}`,
            autoHideDuration: 4000
        });
    }
  }

  // async function openApplicationPreview1() {
  //   await window
  //     .callSpecifiedFunctions(window.activeApplication)
  //     .then((res) => {
  //       window.loading(false);
  //     })
  //     .catch((err) => {
  //       window.loading(false);
  //     });
  // }

  const dataModelClickHandler = (type, shouldFocus, focusElementId) => {
    props.setOpenMicro(type);

    if (shouldFocus) {
      focusElement(document.querySelector(focusElementId), 0);
    }

    // below if condition is being called in IformDesiner useEffect

    // if (type === "dataObject") {
      // window.MdmDataModel(props.appId, props.applicationData?.applicationName);
      // openApplicationPreview1();
    // }
  };

  const customizedDiv = () => {
    return(
      <ButtonGroup
      aria-label="First group"
      //   style={{position: 'absolute', right: 0}}
      style={widthValueForArabicSavePreview}
    >
      
      <UndoRedo
        containerId={props.containerId}
        undoRedoListLength={props.undoRedoListLength}
        handleUndoRedo={(event) => props.handleUndoRedo(event)}
      />

      <Divider
        containerId={props.containerId}
        orientation={"vertical"}
        className={[styles.btnDivider, translationStyles1 ? styles.btnDividerTranslation : ""].join(" ")}
      />

      <Row className={ matches ? styles.themeEditRow : styles.themeEditRowTab}>
        {formState2?.picklistInstanceArray?.length > 0 ? (
          <Tooltip
            title={t(`translation:${"Export All Picklists"}`)}
            classes={{
              tooltip: classes.tooltip,
              arrow: classes.arrow
            }}
            placement={"bottom-start"}
            arrow
          >
            <IconButton
              onClick={() => handleExportPicklist()}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleExportPicklist();
                }
              }}
              className={`${classes.Iconbutton} ${classes.iconButtonroot} ${classes.IconbuttonTheme}`}
              aria-label="Theme"
            >
              <DownloadIcon
                className={[styles.themeIcon, classes.themeIcon].join(" ")}
                style={{ padding: "3px" }}
              />
            </IconButton>
          </Tooltip>
        ) : null}

        {activeApplication && document.querySelector("#interfaceDesignerMain") ? (
         isProcessForm ||
         props.applicationData?.interfaceType?.toString().toLowerCase() === "t" ? null:
         (<Tooltip
            title={t(`translation:Data Model`)}
            classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
            placement={"bottom-start"}
            arrow
          >
            <IconButton
              onClick={() => dataModelClickHandler("dataObject")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  dataModelClickHandler("dataObject", true, "#dataModel_mf_child_div");
                }
              }}
              className={`${classes.Iconbutton} ${classes.iconButtonroot} ${classes.IconbuttonTheme}`}
              aria-label="Theme"
            >
              <DataModel className={[styles.themeIcon, classes.themeIcon].join(" ")} style={{ padding: "0" }} />
            </IconButton>
          </Tooltip>)
        ) : null}

        <Tooltip
          title={t(`translation:THEMES_TOOLTIP_CONTENT`)}
          classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          placement={"bottom-start"}
          arrow
        >
          <IconButton
            onClick={() => {
              setShowTheme("themeDesigner");
              setThemeOpen(true);
              setToggleProperty(false);
              // setOpenProperties(false);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setShowTheme("themeDesigner");
                setThemeOpen(true);
                setToggleProperty(false);
                // setOpenProperties(false);
              }
            }}
            className={`${classes.Iconbutton} ${classes.iconButtonroot} ${classes.IconbuttonTheme}`}
            aria-label="Theme"
          >
            <Layer
              className={[styles.themeIcon, classes.themeIcon, ...(themeOpen ? [classes.themeSelected] : [] )].join(" ")}
              style={{
                cursor: "pointer",
                marginRight: "0",
                ...(themeOpen ? { backgroundColor: "#E5F1F9", border: "1px solid #0072c6" } : {})
              }}
              loading="lazy"
              onClick={() => {
                setShowTheme("themeDesigner");
                setThemeOpen(true);
                setThemeResetDone(false);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setShowTheme("themeDesigner");
                  setThemeOpen(true);
                  setToggleProperty(false);
                }
              }}
              alt="Themes Icon"
            />
          </IconButton>
        </Tooltip>

        <Tooltip
          title={t(`translation:PROPERTIES_TOOLTIP_CONTENT`)}
          classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          placement={"bottom-start"}
          arrow
        >
          <IconButton
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                togglePropertyPanel();
              }
            }}
            className={[
              classes.Iconbutton,
              classes.Settingbutton,
              classes.iconButtonroot,
              translationStyles1 ? styles.IconbuttonTranslation : ""
            ].join(" ")}
            aria-label="Setting"
            disable={disablePropertyBtn}
          >
            <Gear
              className={[styles.propertyIcon, ...(openProperties ? [classes.themeSelected] : [] )].join(" ")}
              alt={"Setting"}
              style={{
                cursor: "pointer",
                border: "1px solid #cdcdcd",
                ...(openProperties ? { backgroundColor: "#E5F1F9", border: "1px solid #0072c6" } : {})
              }}
              onClick={() => togglePropertyPanel()}
            />
          </IconButton>
        </Tooltip>

        {tabMedia ? <FormOptions containerId={props.containerId} /> : null }
      </Row>
    </ButtonGroup>
    )
  }

  return (
    <>
      <ButtonToolbar
        className={styles.DesignerHeader}
        aria-label="Toolbar with Button groups"
        id="designerHeader"
        role="heading"
        aria-level="2"
      >
        <div className={classes.leftActions} style={{minWidth: getCurrentDevice === "mobile" ? "" : "20%"}}>
          <div className={classes.applicationDetails}>
            <Tooltip
              title={props.applicationData?.applicationName}
              classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
              placement={"bottom-start"}
              arrow
            >
              <span className={classes.applicationName}>{props.applicationData?.applicationName}</span>
            </Tooltip>
            {props.applicationData?.status ? (
              <span className={classes.status}>
                <span
                  className={classes.StatusDot}
                  style={{
                    backgroundColor:
                      props.applicationData?.status?.toLowerCase() === "l" ||
                      props.applicationData?.statusType?.toLowerCase() === "l" ||
                      props.applicationData?.status?.toLowerCase() === "draft"
                        ? "#147AFC"
                        : "#29AC47"
                  }}
                ></span>
                {props.applicationData?.status?.toLowerCase() === "l" ||
                props.applicationData?.statusType?.toLowerCase() === "l" ||
                props.applicationData?.status?.toLowerCase() === "draft"
                  ? `${t("DRAFT")}`
                  : `${t("DEPLOYED")}`}
              </span>
            ) : (
              <div></div>
            )}
          </div>
          {props.applicationData?.status ? (
            <Divider
              containerId={props.containerId}
              orientation={"vertical"}
              className={[styles.btnDivider, translationStyles1 ? styles.btnDividerTranslation : ""].join(" ")}
              PagesSubforms_id
            />
          ) : (
            <div></div>
          )}
          <ButtonGroup aria-label="First group" style={widthValueForArabicPages}>
            {(activePage || activeSubForm) && !isButtonSubformOpen && (
              <div
                id="PagesSubforms_id"
                className={classes.formList}
                onClick={() => setShowPagesSubForms(true)}
                style={{
                  // maxWidth: activePage ? "120px" : activeSubForm ? "150px" : "120px"
                  width: activePage
                    ? matches
                      ? "200px"
                      : "120px"
                    : activeSubForm
                    ? matches
                      ? "200px"
                      : "150px"
                    : "120px"
                }}
                role="region"
                aria-label="Pages Sections"
              >
                <Tooltip
                  title={activePage ? activePage?.formName : activeSubForm ? activeSubForm?.fragmentName : ""}
                  classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                  placement={"bottom-start"}
                  arrow
                >
                  <span className={classes.ellipsis}>
                    {activePage && `Page: ${activePage?.formName}`}
                    {activeSubForm && `Subform: ${activeSubForm?.fragmentName}`}
                  </span>
                </Tooltip>

                <span>
                  <DownArrow />
                </span>
              </div>
            )}
          </ButtonGroup>
        </div>

        <ButtonGroup
          aria-label="First group"
          className={classes.deviceBreakpoint}
        >
          <DeviceTypeSelector {...{ props }} containerId={props.containerId} />
        </ButtonGroup>

        <div className={classes.rightActions}>
          {matches && (
            <>
              {customizedDiv()}
              <Divider
                containerId={props.containerId}
                orientation={"vertical"}
                className={[styles.btnDivider, translationStyles1 ? styles.btnDividerTranslation : ""].join(" ")}
              />
            </>
          )}

          <span className={classes.actionButtonGroup}>
            {tabMedia ? null : <FormOptions containerId={props.containerId} />}
              
            {showTheme === "themeDesigner" ? null : <SaveOption containerId={props.containerId} />}

            {activeApplication && document.querySelector("#interfaceDesignerMain") ? (
              <>
                
                  <DullButton
                    className={`${[classes.noMargin, classes.saveButton].join(" ")} dull-button`}
                    disabled={formCorrupt || formLoad}
                    onClick={handleSave}
                  >
                    <Tooltip
                  title={t(`translation:Save`)}
                  classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                  placement={"bottom-start"}
                  arrow
                >
                    {saveload ? <CircularProgress size={10} />: <SaveIcon onClick={handleSave} />}
                    </Tooltip>
                    {props.applicationData?.interfaceType?.toString().toLowerCase() === "t" ||
                    isProcessForm ? null : (
                      <img
                        tabIndex="0"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.stopPropagation();
                            setOpenPopupSave(!openPopupSave);
                          }
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenPopupSave(true);
                        }}
                        src={DownArrow1}
                        className={classes.downArrow}
                        alt={"Down Icon"}
                      />
                    )}
                    {isProcessForm && t(`translation:${"Save"}`)}
                  </DullButton>
                  {props.applicationData?.interfaceType?.toString().toLowerCase() === "t" ||
                    isProcessForm ? null : (
                      <MoreSaveOptions
                        applicationData={props.applicationData}
                        openPopupSave={openPopupSave}
                        setOpenPopupSave={setOpenPopupSave}
                        saveAppTemplate_popup={saveAppTemplate_popup}
                        setSaveAppTemplate_popup={setSaveAppTemplate_popup}
                        containerId={props.containerId}
                      />
                    )}
                {isProcessForm ||
                props.applicationData?.interfaceType?.toString().toLowerCase() === "t" ? null : (
                  <Tooltip
                    title={t(`translation:Deploy`)}
                    classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                    placement={"bottom-start"}
                    arrow
                  >
                    <BlueButton
                      tabIndex={0}
                      className={`${classes.deployButton} blue-button`}
                      onKeyDown={(event) => event.key == "Enter" && handleDeployClick()}
                      onClick={handleDeployClick}
                      disabled={
                        formCorrupt ||
                        formLoad ||
                        props.applicationData?.status?.toLowerCase() === "deployed" ||
                        props.applicationData?.status?.toLowerCase() === "published"
                      }
                    >
                      <Deployed />
                      {tabMedia ? null : t(`translation:${"Deploy"}`)}
                    </BlueButton>
                  </Tooltip>
                )}
              </>
            ) : null}
          </span>
          {isMarvinEnabled && !openCanvasForSubform && (
            <Divider
              containerId={props.containerId}
              orientation={"vertical"}
              className={[styles.btnDivider, translationStyles1 ? styles.btnDividerTranslation : ""].join(" ")}
            />
          )}
          {isMarvinEnabled &&
            !openCanvasForSubform &&
            (isMarvinDisabled ? (              
                <img
                  className={styles.headerMarvinIcon}
                  src={require(`../../../../Icons/Marvin/Marvin Icon-disabled.svg`).default}
                  alt={"Marvin Disabled"}
                  style={{ cursor: "no-drop" }}
                />              
            ) : marvinButtonSelected ? (
              <Tooltip
                title={t(`translation:Ask Marvin`)}
                classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                placement={"bottom-start"}
                arrow
              >
                <img
                  className={styles.headerMarvinIcon}
                  src={require(`../../../../Icons/Marvin/marvinIconSelected.svg`).default}
                  alt={"Marvin Selected"}
                />
              </Tooltip>
            ) : (
              <Tooltip
                title={t(`translation:Ask Marvin`)}
                classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                placement={"bottom-start"}
                arrow
              >
                <img
                  className={styles.headerMarvinIcon}
                  src={require(`../../../../Icons/Marvin/MarvinIcon.svg`).default}
                  alt={"Marvin"}
                  onClick={() => handleMarvinFormOpen(props.containerId, controlSelected)}
                />
              </Tooltip>
            ))}
          <MarvinContainer />
          {showTheme === "themeSelector" ? (
            <ThemeSelector
              // updateTheme = {updateTheme}
              // setUpdateTheme = {setUpdateTheme}
              containerId={props.containerId}
              key={showTheme}
              showTheme={showTheme}
              themeList={props.themeList}
              handleThemeList={(action, newTheme) => handleThemeList(action, newTheme)}
              handleThemeSelector={(action, theme) => handleThemeSelector(action, theme)}
              setThemeList={props.setThemeList}
            />
          ) : showTheme === "themeDesigner" ? (
            <ThemesLayout
              // formPageStyle={formPageStyle}
              setThemeList={props.setThemeList}
              formStateTheme={formStateTheme}
              containerId={props.containerId}
              key={showTheme}
              state={true}
              showTheme={showTheme}
              setShowTheme={(arg) => setShowTheme(arg)}
              themeDetailsReset={themeDetailsReset}
              setThemeDetailsReset={setThemeDetailsReset}
              themeList={props.themeList}
              formState2={formState2}
              handleThemeList={(action, newTheme) => handleThemeList(action, newTheme)}
              selectedTheme={formState2.theme || props.formData.theme}
              formData={props.formData}
              applyChanges={(ev, saveOldState) => props.applyChanges(ev, saveOldState)}
              handleThemeSelector={(action, theme, str) => handleThemeSelector(action, theme, str)}
              distanceFromTop={distanceFromTop.current !== undefined && distanceFromTop.current}
            />
          ) : null}
        </div>

        {alertData.open === true && <CustomizedAlert alertData={alertData} />}
      </ButtonToolbar>
      {!matches && (
        <ButtonToolbar
          className={styles.DesignerHeader2}
          aria-label="Toolbar with Button groups 2"
          id="designerHeader2"
          role="heading"
          aria-level="2"
        >
          {customizedDiv()}
        </ButtonToolbar>
      )}
    </>
  );
};

export default DesignerHeader;
